module.exports = __webpack_public_path__ + "img/eachMark.c92c098b.jpg";